export default "__VITE_ASSET__18ae88ea__"